<template>
    <div>
        <NavBarAdmin></NavBarAdmin>
        <h3 class="mt-3">Nueva lámina metálica</h3>
        <FormNewSheet></FormNewSheet>
        <FooterAdmin></FooterAdmin>
    </div>
</template>
<script>
import NavBarAdmin from "@/components/Admin/NavbarAdminComponent.vue"
import FormNewSheet from "@/components/Admin/Sheet/NewSheetFormComponent.vue" 
import FooterAdmin from "@/components/Admin/FooterAdminComponent.vue"
export default {
  name: "New Sheet",
  components: {
    NavBarAdmin,
    FormNewSheet,
    FooterAdmin,
  },
  data() {},
  methods: {},
};
</script>
<style scoped>

</style>